import './result.scss';

import { createElementFromHTML, checkAndLoadFiles } from '../../utilities/js/helper';

class SearchResults {
    constructor ($element) {
        this.$searchResults = $element;
        this.$searchResultsList = null;
        this.$searchResultsLoadMore = null;
        this.$tabNavigation = this.$searchResults.querySelector('[data-tab-navigation="root"]');
        this.$$searchResultsCategoryLink = [];
        this.$loadingSpinner = createElementFromHTML(window.OPTIONS.loader);

        this.initialize();
    }

    initialize () {
        this.setEvents(this.$searchResults);

        window.addEventListener('tab_navigation.tab_fetch', (e) => {
            this.fetchTabContentFromUrl(e.detail.$context);
        });

        window.addEventListener('filter_bar.update_filter', (e) => {
            window.dispatchEvent(new CustomEvent('tab_navigation.update_tabs', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: e.detail.$context
                }
            }));
        });
    }

    setEvents ($root) {
        this.$$searchResultsCategoryLink = $root.querySelectorAll('[data-search-results="category-link"]');
        this.$searchResultsList = $root.querySelector('[data-search-results="list"]');
        this.$searchResultsLoadMore = $root.querySelector('[data-search-results="load-more"]');

        if (this.$$searchResultsCategoryLink.length > 0) {
            this.$$searchResultsCategoryLink.forEach($searchResultsCategoryLink => {
                $searchResultsCategoryLink.onclick = () => {
                    const categoryKey = $searchResultsCategoryLink.dataset.searchResultsCategoryKey;

                    if (categoryKey !== undefined) {
                        const $categoryTab = this.$tabNavigation.querySelector(`[data-tab-key="${categoryKey}"]`) || null;

                        if ($categoryTab !== null) {
                            $categoryTab.click();
                        }
                    }
                };
            });
        }

        if (this.$searchResultsLoadMore != null && this.$searchResultsList != null) {
            this.$searchResultsLoadMore.onclick = () => {
                this.$searchResultsLoadMore.setAttribute('aria-pressed', 'true');

                this.fetchSearchResultsList(this.$searchResultsList, this.$searchResultsLoadMore.dataset.paginationUrl || null);
            };
        }
    }

    fetchSearchResultsList ($searchResultsList, fetchUrl) {
        $searchResultsList.appendChild(this.$loadingSpinner);

        if (fetchUrl !== null) {
            fetch(fetchUrl, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
                .then(response => {
                    if (!response.ok && response.status !== 422) {
                        throw new Error(`HTTP ERROR: ${response.status}`);
                    }
                    return response.text();
                })
                .then(data => {
                    if (data) {
                        const $resultContent = createElementFromHTML(data);
                        const $searchResultsListContent = $resultContent.querySelector('[data-search-results="list"]');

                        // important - remove the old load more button before getting a new one
                        this.$searchResultsLoadMore.parentElement.remove();

                        if ($searchResultsListContent) {
                            const countListItemsBefore = $searchResultsList.querySelectorAll('a').length;

                            $searchResultsList.innerHTML += $searchResultsListContent.innerHTML;

                            // get the first link of the new list in the old list
                            const $firstNewLink = $searchResultsList.querySelectorAll('a')[countListItemsBefore];

                            if ($firstNewLink) {
                                $firstNewLink.focus();
                            }

                            window.dispatchEvent(new CustomEvent('content.loaded', {
                                view: window,
                                bubbles: true,
                                cancelable: false,
                                detail: {
                                    $context: $searchResultsList
                                }
                            }));

                            this.removeLoader($searchResultsList);
                            this.setEvents($searchResultsList.parentElement);
                        }
                    }
                })
                .catch(error => {
                    console.error('ERROR:', error);
                    this.removeLoader($searchResultsList);
                });
        }
    }

    fetchTabContentFromUrl ($activeTab) {
        const $activeTabPanel = this.$tabNavigation.querySelector(`#${$activeTab.getAttribute('aria-controls')}`);
        const fetchUrl = $activeTab.dataset.tabNavigationFetchUrl || null;

        if ($activeTabPanel !== undefined && fetchUrl !== null) {
            window.dispatchEvent(new CustomEvent('tab_navigation.clear_tab_panels', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$tabNavigation
                }
            }));

            $activeTabPanel.appendChild(this.$loadingSpinner);

            fetch(fetchUrl, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
                .then(response => {
                    if (!response.ok && response.status !== 422) {
                        throw new Error(`HTTP ERROR: ${response.status}`);
                    }
                    return response.text();
                })
                .then(data => {
                    if (data) {
                        const $resultContent = createElementFromHTML(data);
                        let $tabPanelContent;

                        $tabPanelContent = $resultContent.querySelector(`#${$activeTabPanel.id}`);

                        if ($tabPanelContent === undefined) {
                            $tabPanelContent = $resultContent;
                        }

                        window.dispatchEvent(new CustomEvent('tab_navigation.update_tabs', {
                            view: window,
                            bubbles: true,
                            cancelable: false,
                            detail: {
                                $context: $resultContent
                            }
                        }));

                        $activeTabPanel.innerHTML = $tabPanelContent.innerHTML;

                        checkAndLoadFiles($activeTabPanel).then((data) => {
                            window.dispatchEvent(new CustomEvent('content.loaded', {
                                view: window,
                                bubbles: true,
                                cancelable: false,
                                detail: {
                                    $context: $activeTabPanel
                                }
                            }));
                        });

                        this.setEvents($activeTabPanel);
                        this.setHistory(fetchUrl);
                    }
                })
                .catch(error => {
                    console.error('ERROR:', error);
                    this.removeLoader($activeTab);
                });
        }
    }

    setHistory (uri) {
        history.pushState(null, document.title, uri);
    }

    removeLoader ($container) {
        const $loader = $container.querySelector('[data-loader]');

        if ($loader) {
            $loader.remove();
        }
    }
}

export { SearchResults };

window.addEventListener('content.loaded', (e) => {
    const $$searchResults = e.detail.$context.querySelectorAll('[data-search-results="root"]');

    if ($$searchResults.length > 0) {
        $$searchResults.forEach(($searchResults) => {
            const searchResults = new SearchResults($searchResults); // eslint-disable-line
        });
    }
});
